module.exports = __webpack_public_path__ + "media/video.b169489f.mp4";